import Container from '@material-ui/core/Container';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Storage } from "aws-amplify";
import styles from './index.module.css';
import { IAppState } from '../../store';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Dialog from '@material-ui/core/Dialog/Dialog';
import Authenticator from "../views/Auth"
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useHistory, useLocation } from 'react-router-dom';
import { AccountType, UserRole } from '../../reducers/auth/types';
import { CircularProgress, createStyles, Hidden, withStyles } from '@material-ui/core';
import { getLocalizedBookingSyntex } from '../../utils/localized.syntex';
import { clearTestDriveBooking } from '../../actions/testDriveBooking/actions';
import SideBar from '../views/CustomerPortal/Sidebar';
import { getSignedUrl } from '../../utils/getSignedUrl';
import LanguageSelector from '../LanguageSelector';
import { useTranslation } from 'react-i18next';
import { NotificationButton } from './Notification';

export const WhiteCircularProgress = withStyles(() =>
  createStyles({
    root: {
      color: '#fff !important',
      width: 20,
      height: 20
    },
  }),
)(CircularProgress);

interface Props {
  height: number
  logoSize: number
  accountScreen?: boolean
}

export const TopBar: React.FC<Props> = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [logoUrl, setLogoUrl] = useState<any>("");
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const { country } = website.organisation.address;
  const authState = useSelector((state: IAppState) => state.authReducer);
  const user = useSelector((state: IAppState) => state.authReducer.user);
  const [authDialogOpen, setAuthDialogOpen] = useState<boolean>(false);
  const { t } = useTranslation();
  document.title = website.websiteTitle || website.organisation.name;

  useEffect(() => {
    if (website) {
      getLogoUpload(website.websiteLogo || website.organisation.logoUrl);
    }
  }, [website]);


  const getLogoUpload = async (logoUrl: string) => {
    const file = await getSignedUrl(logoUrl).then((result) => {
      return result;
    }).catch((err) => {
    });
    const response = await fetch(file as string).then((res) => {
      return res;
    });
    if (!response.ok) {
      setLogoUrl("");
      return;
    }
    setLogoUrl(file);
  };

  const hashttp = (url: string) => {
    return /\b(http:|https:)/.test(url);
  }

  const onSignIn = () => {
    setAuthDialogOpen(false);
  }

  const resetBookingStoreAndNavigate = () => {
    dispatch(clearTestDriveBooking());
    history.push("/");
  }

  const companyWebsiteURL = website.companyWebsite ? hashttp(website.companyWebsite) ? website.companyWebsite : `http://${website.companyWebsite}` : "/";

  return (
    <div className={styles.topBar} style={{ height: props.height || 70 }}>
      <Container>
        <div className={styles.topBarWrapper}>
          <Hidden smUp>
            {location.pathname.includes('/account') && <SideBar />}
          </Hidden>
          <a href={companyWebsiteURL} className={styles.topBarLogo} style={{ height: props.logoSize }}>
            {logoUrl ? <img className={styles.topBarLogo} src={logoUrl} alt="logo" /> : <WhiteCircularProgress size="small" thickness={5} />}
          </a>
          <div className="fill padding-left padding-right" style={{ marginLeft: 20 }}>
            <div className={styles.topBarTitle} dangerouslySetInnerHTML={{ __html: website.websiteHeader || "" }}>
            </div>
          </div>

          {authState.authUser?._id && user?.active && <NotificationButton />}

          <LanguageSelector />

          {
            website.tenancy.loginEnabled &&
            (
              !props.accountScreen ||
              (props.accountScreen && authState.accountType === AccountType.INDIVIDUAL) ||
              (props.accountScreen && authState.accountType === AccountType.BUSINESS && !user?.businesscustomers?.portalBookingDisabled) &&
              ((website.organisation.enableBookingCreationForApprovedDriver && user?.role == UserRole.DRIVER) || user?.role !== UserRole.DRIVER)
            ) && (
              <div className={styles.auth} onClick={() => props.accountScreen && user?.active ? resetBookingStoreAndNavigate() : authState.authUser?._id && user?.active ? history.push("/account") : setAuthDialogOpen(true)}>
                <div className={styles.iconWrap}>
                  {props.accountScreen ? <AddCircleIcon fontSize="small" /> : <AccountCircleIcon fontSize="small" />}
                </div>
                <span className={styles.topBarButtonTitle}>{props.accountScreen ? `${t("root:new")} ${getLocalizedBookingSyntex(country)}` : authState.authUser?._id ? t("root:account") : t("misc:signIn")}</span>
              </div>
            )
          }
        </div>
      </Container>
      <Dialog open={authDialogOpen} onClose={() => setAuthDialogOpen(false)} maxWidth="md" >
        <div className={styles.authDialog}>
          <Authenticator onSignIn={onSignIn} />
        </div>
      </Dialog>
    </div>

  )
}